import React, { useState } from 'react'
import { useHistory } from 'react-router'
import FileUploader from '../flleUploader/index.js'
import './styles.css'

// constant for action status => edit manual file

const ManualFileUploadForm = ({
    setAlert,
    setShowAlert,
    setLgShow,
    fileName,
    fileId,
    delimiter,
    area_for_business_data,
    extensionFile,
    encoding,
    selectedData
}) => {
    // create object history
    const history = useHistory();

    // const handleUpload = (event) => {
    //     setAlert({
    //         header: 'Upload finalizado com sucesso.',
    //         message: "O arquivo encontra-se armazenado na nuvem. Aguarde a execução agendada no Databricks para que os dados sejam refletidos no catalogo platform do Lakehouse",
    //         type: 'success',
    //         options_btn: []
    //     })
    //     setShowAlert(true)
    //     setLgShow(false)
    // }

    return (
        <div>
            <UploadManualFile
                setLgShow={setLgShow}
                setAlert={setAlert}
                setShowAlert={setShowAlert}
                fileName={fileName}
                fileId={fileId}
                delimiter={delimiter}
                area_for_business_data={area_for_business_data}
                extensionFile={extensionFile}
                encoding={encoding}
                selectedData={selectedData}
            />
        </div>
    );
}

const UploadManualFile = ({
    setLgShow,
    setAlert,
    setShowAlert,
    fileName,
    fileId,
    delimiter,
    area_for_business_data,
    extensionFile,
    encoding,
    selectedData
}) => (
    <FileUploader
        setLgShow={setLgShow}
        setAlert={setAlert}
        setShowAlert={setShowAlert}
        fileName={fileName}
        fileId={fileId}
        delimiter={delimiter}
        area_for_business_data={area_for_business_data}
        extensionFile={extensionFile}
        encoding={encoding}
        selectedData={selectedData}
    />
)


export default ManualFileUploadForm;
